<a class="product-card" [class.featured]="isFeatured()" [routerLink]="['/catalogo', slug()]">
  <div class="image-wrapper">
    <img
      [src]="getSafeImageUrl()"
      [alt]="name()"
      loading="lazy"
      decoding="async"
      (error)="onImageError()"
    >
  </div>
  <div class="product-info">
    <h4 class="product-name">{{ name() }}</h4>
    <div class="product-card__price-row">
      <span class="product-price" [class.product-price--coming-soon]="status() === 'coming_soon'">{{ price() }}</span>
      @if (status() === 'coming_soon') {
        <span class="product-card__availability">— Próximamente</span>
      }
    </div>
  </div>
</a>
